import { useEffect, useRef, useState } from "react";
import {
  useAlertStore,
  useGeneralStore,
  usePopupStore,
  useThemeStore,
} from "../../../stores";
import { Cheque, ChequeSelectorItem, Customer, Factor } from "../../../types";
import { UpdateReceivedFactorProps } from "./types";
import { Column, Row } from "../../containers";
import { PopupBack, PopupClose } from "../../../popup";
import { Heading } from "../../typography";
import { ChequeMultiForm, ChequeSelector } from "../../cheque";
import { FactorApi } from "../../../api";
import { SelectorInput, TextInput } from "../../inputs";
import { Button } from "../../buttons";
import { JustifyContent } from "../../containers/types";
import { ChequeMultiFormRef } from "../../cheque/cheque-multi-form/types";

const UpdateReceivedFactor = <T extends {} & { factor: Factor }>(
  props: UpdateReceivedFactorProps<T>
) => {
  const { factor, back, updateCb } = props;

  const chequesRef = useRef<ChequeMultiFormRef>(null);

  const theme = useThemeStore((s) => s.theme);
  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);
  const customers = useGeneralStore((s) => s.customers);
  const getCustomerById = useGeneralStore((s) => s.getCustomerById);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);
  const pushAlert = useAlertStore((s) => s.pushAlert);

  useEffect(() => {
    setPopupProperties({
      style: {
        maxHeight: "80%",
        overflowY: "auto",
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const [cheques, setCheques] = useState<Array<Cheque>>([]);

  const [customer, setCustomer] = useState<Customer | null>(null);
  const [desc, setDesc] = useState<string>("");
  const [delCheques, setDelCheques] = useState<Array<ChequeSelectorItem>>([]);

  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setCustomer(getCustomerById(factor.customer.$oid));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [factor.customer.$oid]);

  useEffect(() => {
    FactorApi.getCheques(factor._id)
      .then((res) => {
        setCheques(res);
      })
      .catch((err) => {
        pushAlert(err.msg || "unknown error", "error");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const onSave = (): void => {
    setLoading(true);
    FactorApi.updateRecvFactor(
      factor._id.$oid,
      customer,
      desc,
      delCheques,
      chequesRef.current?.isValid()
        ? chequesRef.current?.getCheques() || []
        : [],
      chequesRef.current?.isValid() ? chequesRef.current?.getFiles() || [] : []
    )
      .then((res) => {
        if (updateCb) updateCb();
        setPopupBody(
          back ? <back.component {...back.props} factor={res} /> : null
        );
        pushAlert("عملیات موفقیت آمیز");
      })
      .catch((err) => {
        pushAlert(err.msg || "unknown error", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Column style={{ padding: "1rem", position: "relative" }} gap={20}>
      <PopupClose />

      {back ? (
        <PopupBack Component={back.component} props={back.props} />
      ) : (
        <></>
      )}

      <Heading color={theme.textOnOverlay} size={18}>
        ویرایش فاکتور دریافت شده
      </Heading>

      <Row style={{ width: "100%" }} gap={20} className="factor-activity-row">
        <SelectorInput<Customer>
          items={customers}
          uniqueKey={"fullname"}
          selected={customer}
          setSelected={setCustomer}
          stringField={"fullname"}
          renderStrings={["fullname", "phone"]}
          compareFn={(c, v) =>
            c.fullname.toLowerCase().includes(v.toLowerCase()) ||
            c.phone.includes(v)
          }
          label="نام مشتری"
        />

        <TextInput
          label="بابت"
          value={desc}
          setValue={setDesc}
          inputProps={{ placeholder: factor.description }}
        />
      </Row>

      <ChequeSelector
        items={cheques}
        label="حذف چک"
        selectedItems={delCheques}
        setSelectedItems={setDelCheques}
        canDel
      />

      <ChequeMultiForm style={{ width: "100%" }} ref={chequesRef} />

      <Row style={{ width: "100%" }} justifyContent={JustifyContent.End}>
        <Button
          background={theme.primary}
          color={theme.textOnprimary}
          onClick={onSave}
          loading={loading}
        >
          ذخیره
        </Button>
      </Row>
    </Column>
  );
};

export default UpdateReceivedFactor;
